import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
    size?: 'sm' | 'md' | 'lg';
    linkTo?: string;
}

const sizeClass = {
    sm: 'text-lg',
    md: 'text-[1.35rem]',
    lg: 'text-3xl',
};

export default function Logo({ size = 'md', linkTo = '/' }: LogoProps) {
    return (
        <>
            <style>{`
                .fancy-logo {
                    position: relative;
                    display: inline-block;
                    color: #fff;
                    letter-spacing: 0.15em;
                    text-shadow:
                        0.05em 0 0 rgba(255,0,255,0.75),
                        -0.025em -0.05em 0 rgba(0,255,255,0.75),
                        0.025em 0.05em 0 rgba(255,255,0,0.75);
                    animation: logo-glitch 3000ms infinite;
                }
                .fancy-logo::before,
                .fancy-logo::after {
                    content: attr(data-text);
                    position: absolute;
                    top: 0; left: 0;
                    width: 100%; height: 100%;
                    opacity: 0.8;
                }
                .fancy-logo::before { animation: glitch-layers 4000ms infinite; color: #00ffff; z-index: -1; }
                .fancy-logo::after  { animation: glitch-layers 2500ms infinite; color: #ff00ff; z-index: -2; }
                @keyframes logo-glitch {
                    0%   { text-shadow: 0.05em 0 0 rgba(255,0,255,.75), -0.025em -0.05em 0 rgba(0,255,255,.75), 0.025em 0.05em 0 rgba(255,255,0,.75); }
                    14%  { text-shadow: 0.05em 0 0 rgba(255,0,255,.75), -0.025em -0.05em 0 rgba(0,255,255,.75), 0.025em 0.05em 0 rgba(255,255,0,.75); }
                    15%  { text-shadow: -0.05em -0.025em 0 rgba(255,0,255,.75), 0.025em 0.025em 0 rgba(0,255,255,.75), -0.05em -0.05em 0 rgba(255,255,0,.75); }
                    49%  { text-shadow: -0.05em -0.025em 0 rgba(255,0,255,.75), 0.025em 0.025em 0 rgba(0,255,255,.75), -0.05em -0.05em 0 rgba(255,255,0,.75); }
                    50%  { text-shadow: 0.025em 0.05em 0 rgba(255,0,255,.75), 0.05em 0 0 rgba(0,255,255,.75), 0 -0.05em 0 rgba(255,255,0,.75); }
                    99%  { text-shadow: 0.025em 0.05em 0 rgba(255,0,255,.75), 0.05em 0 0 rgba(0,255,255,.75), 0 -0.05em 0 rgba(255,255,0,.75); }
                    100% { text-shadow: -0.025em 0 0 rgba(255,0,255,.75), -0.025em -0.025em 0 rgba(0,255,255,.75), -0.025em -0.05em 0 rgba(255,255,0,.75); }
                }
                @keyframes glitch-layers {
                    0%   { transform: translate(0); }
                    20%  { transform: translate(-3px,  3px); }
                    40%  { transform: translate(-3px, -3px); }
                    60%  { transform: translate( 3px,  3px); }
                    80%  { transform: translate( 3px, -3px); }
                    100% { transform: translate(0); }
                }
                .logo-container {
                    background:
                        linear-gradient(rgba(18,16,16,0) 50%, rgba(0,0,0,0.25) 50%),
                        linear-gradient(90deg, rgba(255,0,0,0.06), rgba(0,255,0,0.02), rgba(0,0,255,0.06));
                    background-size: 100% 2px, 3px 100%;
                    padding: 4px 8px;
                    border: 1px solid rgba(0,207,252,0.3);
                    box-shadow: inset 0 0 15px rgba(0,207,252,0.2), 0 0 10px rgba(0,207,252,0.1);
                }
            `}</style>
            <Link to={linkTo} className="select-none">
                <div className="logo-container flex items-center justify-center">
                    <span
                        className={`fancy-logo ${sizeClass[size]} font-['Space_Grotesk'] font-black italic uppercase`}
                        data-text="STARTZONE.DEV"
                    >
                        STARTZONE<span className="text-[#00cffc] relative contents">.DEV</span>
                    </span>
                </div>
            </Link>
        </>
    );
}
